import axios from 'axios';

const API = process.env.REACT_APP_API_BASE_URL;

// Public storefront settings, fetched once and shared; call refreshPublicSettings() after admin changes
let publicSettings = null;
export const getPublicSettings = () => {
    if (!publicSettings) {
        publicSettings = axios.get(`${API}/settings/public`)
            .then(r => r.data)
            .catch(() => { publicSettings = null; return {}; });
    }
    return publicSettings;
};
export const refreshPublicSettings = () => { publicSettings = null; return getPublicSettings(); };

// Admin: integrations
export const listIntegrations = async () => (await axios.get(`${API}/admin/integrations`)).data.integrations;
export const saveIntegration = async (key, changes) => (await axios.put(`${API}/admin/integrations/${key}`, changes)).data.integration;
export const testIntegration = async (key) => (await axios.post(`${API}/admin/integrations/${key}/test`)).data;
